import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgXalertErrorIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M16 2.5C23.4558 2.5 29.5 8.54416 29.5 16C29.5 23.4558 23.4558 29.5 16 29.5C8.54416 29.5 2.5 23.4558 2.5 16C2.5 8.54416 8.54416 2.5 16 2.5Z",
			fill: "#FDF0F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16 2.5C23.4558 2.5 29.5 8.54416 29.5 16C29.5 23.4558 23.4558 29.5 16 29.5C8.54416 29.5 2.5 23.4558 2.5 16C2.5 8.54416 8.54416 2.5 16 2.5Z",
			stroke: "#FEE2E2",
			strokeWidth: 5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.2715 14.4306V16.886M10.2103 19.0966C9.64603 20.0788 10.3516 21.3059 11.4794 21.3059H21.0635C22.1906 21.3059 22.8962 20.0788 22.3327 19.0966L17.5413 10.7493C16.9771 9.76715 15.5659 9.76715 15.0016 10.7493L10.2103 19.0966ZM16.2715 18.8504H16.276V18.8556H16.2715V18.8504Z",
			stroke: "#CE0016",
			strokeWidth: 1.06088,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgXalertErrorIcon;
